module.exports = __webpack_public_path__ + "static/media/substack.74b31914.svg";